import React from 'react';
import styled from 'styled-components';

import AnchorLink from './AnchorLink';
import RouterLink from './RouterLink';

const Link = styled(props => (
  props.to
    ? <RouterLink {...props} aria-label={props.destination}>{props.children}</RouterLink>
    : <AnchorLink {...props} aria-label={props.destination}>{props.children}</AnchorLink>
)).attrs({ className: 'with-ruler' })``;

export default Link;
